import list from './list'
import create from './create'
import show from './show'
import update from './update'
import createModal from './createModal'

export default {
  namespaced: true,
  modules: {
    list,
    create,
    show,
    update,
    createModal
  }
}
